import { ENDPOINT_AUTH_LOGIN } from './Endpoints'
import { API_URL } from '../utils/constantes'

export const AUTH_EXPIRED_EVENT = 'planning:auth-expired'
export const PLANNING_REAUTH_SUCCESS = 'PLANNING_REAUTH_SUCCESS'

const REAUTH_POPUP_PARAM = 'reauth'
const REAUTH_POPUP_VALUE = 'popup'
const REAUTH_POPUP_NAME = 'planning-sso-reauth'
const REAUTH_POPUP_FEATURES = 'popup,width=520,height=720,menubar=no,toolbar=no,location=no'

const getCurrentRedirectPath = () => {
  const currentUrl = new URL(window.location.href)
  currentUrl.searchParams.set(REAUTH_POPUP_PARAM, REAUTH_POPUP_VALUE)
  return `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
}

export const buildReauthLoginUrl = () => {
  const loginUrl = new URL(`${API_URL}${ENDPOINT_AUTH_LOGIN}`)
  loginUrl.searchParams.set('redirect', getCurrentRedirectPath())
  return loginUrl.toString()
}

export const openReauthPopup = () => {
  return window.open(buildReauthLoginUrl(), REAUTH_POPUP_NAME, REAUTH_POPUP_FEATURES)
}

export const isPopupReauthRedirect = (redirectPath) => {
  if (!redirectPath) return false

  try {
    const redirectUrl = new URL(redirectPath, window.location.origin)
    return redirectUrl.searchParams.get(REAUTH_POPUP_PARAM) === REAUTH_POPUP_VALUE
  } catch {
    return false
  }
}

export const removePopupReauthParam = (redirectPath) => {
  try {
    const redirectUrl = new URL(redirectPath, window.location.origin)
    redirectUrl.searchParams.delete(REAUTH_POPUP_PARAM)
    return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`
  } catch {
    return redirectPath
  }
}

export const dispatchAuthExpiredEvent = (detail = {}) => {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail }))
}
